import { render, staticRenderFns } from "./dpubtop.vue?vue&type=template&id=058e4238&scoped=true&"
import script from "./dpubtop.vue?vue&type=script&lang=js&"
export * from "./dpubtop.vue?vue&type=script&lang=js&"
import style0 from "./dpubtop.vue?vue&type=style&index=0&id=058e4238&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e4238",
  null
  
)

export default component.exports